export default (token) => {
    const commissionPrefix = 'store_platform_contract_workflow_for_edit_commissions_obj_attributes_'
    const campaignPrefix = 'store_platform_contract_workflow_for_edit_campaigns_obj_attributes_'

    const xhr = new XMLHttpRequest()
    xhr.open('GET', '/api/v1/store_platform_contract_workflows/information')
    xhr.setRequestHeader( 'X-CSRF-Token', token)
    xhr.setRequestHeader('Content-Type', 'application/json')
    xhr.send()
    xhr.addEventListener('load', function(result) {
        if(result.currentTarget.status != 200) {
            alert(result.currentTarget.responseText)
            return
        }
        if(result.currentTarget.responseText.length == 0) {
            return
        }

        const json = JSON.parse(result.currentTarget.responseText)

        Array.from(document.getElementsByClassName("commission_row")).forEach(element => {
            setCommissionInfo(element, json.commission)
        });

        Array.from(document.getElementsByClassName("campaign_row")).forEach(element => {
            setCampaignInfo(element, json.campaign)
        });

    })

    const setCommissionInfo = (el, json) => {
        let contractCommissionId = null
        Array.from(el.getElementsByTagName("input")).some(inputEl => {
            if(!inputEl.id.match(new RegExp(`^${commissionPrefix}[0-9]+_id`), "")) {
                return false
            }
            if(inputEl.value.length === 0) return false
            contractCommissionId = inputEl.value
            return true
        })

        Array.from(el.getElementsByClassName("watch_changes")).forEach(element => {
            let commissionId = element.value
            if(commissionId === '') {
                resetCommission(el)
                return
            }
            commissionId = commissionId - 0

            let jsonParams = null
            Array.from(json).some(params => {
                if(params.id !== commissionId) {
                    return false
                }
                jsonParams = params
                return true
            })
            if(jsonParams === null) return

            Array.from(el.getElementsByTagName("input")).forEach(inputEl => {
                let name = inputEl.id
                const column = name.replace(new RegExp(`^${commissionPrefix}[0-9]+_`), "")
                switch(column) {
                    case 'price':
                        inputEl.readOnly = true
                        inputEl.disabled = true
                        if(contractCommissionId === null) {
                            inputEl.readOnly = false
                            inputEl.disabled = false
                            if(jsonParams.default_price !== null) {
                                inputEl.value = jsonParams.default_price
                            }
                        }
                        break
                }
            })
        })
    }

    const resetCommission = (el) => {
        Array.from(el.getElementsByTagName("input")).forEach(inputEl => {
            let name = inputEl.id
            const column = name.replace(new RegExp(`^${commissionPrefix}[0-9]+_`), "")
            switch(column) {
                case 'price':
                    inputEl.readOnly = false
                    inputEl.disabled = false
                    inputEl.value = null
                    break
            }
        })
    }

    const setCampaignInfo = (el, json) => {
        Array.from(el.getElementsByClassName("watch_changes")).forEach(element => {
            let campaignId = element.value
            if(campaignId === '') {
                resetCampaign(el)
                return
            }
            campaignId = campaignId - 0

            let jsonParams = null
            Array.from(json).some(params => {
                if(params.id !== campaignId) {
                    return false
                }
                jsonParams = params
                return true
            })
            if(jsonParams === null) return

            Array.from(el.getElementsByTagName("input")).forEach(inputEl => {
                let name = inputEl.id
                const column = name.replace(new RegExp(`^${campaignPrefix}[0-9]+_`), "")
                switch(column) {
                    case 'code':
                        inputEl.readOnly = true
                        inputEl.disabled = true
                        inputEl.value = jsonParams.code
                        break
                }
            })
            Array.from(el.getElementsByClassName("staff_memo")).forEach(inputEl => {
                inputEl.innerHTML = jsonParams.staff_memo
            })
        })
    }

    const resetCampaign = (el) => {
        Array.from(el.getElementsByTagName("input")).forEach(inputEl => {
            let name = inputEl.id
            const column = name.replace(new RegExp(`^${campaignPrefix}[0-9]+_`), "")
            switch(column) {
                case 'code':
                    inputEl.readOnly = false
                    inputEl.disabled = false
                    inputEl.value = ''
                    break
            }
        })
        Array.from(el.getElementsByClassName("staff_memo")).forEach(inputEl => {
            inputEl.innerHTML = ''
        })
    }
}
